import React, { useState, useCallback, useEffect } from "react";
import { producaov2 as api } from "../../../../services/apis";
import { Button, Form, Input } from "semantic-ui-react";
import * as yup from "yup";
import { toast } from "react-toastify";

import { Container, Content, Title, Image } from "./styles";

import swal from "sweetalert";
import { Link, withRouter } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import Dropzone from "../../../../components/Admin/Dropzone";
import { isAuthAdmin } from "../../../../services/auth";

const EditarBandeira = (props) => {
  const id = props.match.params.id;
  const [selectedFile, setSelectedFile] = useState("");
  const [taxas, setTaxas] = useState([{ tarifa: "", parcelas: "" }]);
  const [bandeira, setBandeira] = useState({});
  const parcelas = [
    { id: 1, valor: "1x" },
    { id: 6, valor: "2x a 6x" },
    { id: 12, valor: "7x a 12x" },
  ];

  const uploadImage = async () => {
    try {
      const inputData = new FormData();

      inputData.append("file", selectedFile);
      inputData.append("path", "imagens-voitto/imagens-blog/meta/ctas");

      const response = await api.post("/upload", inputData);
      const { url } = response.data;

      setBandeira({ ...bandeira, img: url });

      toast.success("A operação foi concluida com sucesso!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (err) {
      toast.error("A operação falhou, verifique o arquivo e tente novamente", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  useEffect(() => {
    loadAuth();
    loadBandeira();
  }, []);
  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const loadBandeira = () => {
    api
      .get("/admin/bandeira")
      .then(async (res) => {
        const bandeira = [...res.data].filter((band) => band.id == id);
        const taxa = JSON.parse(bandeira[0].taxas);
        let array = {
          local: "bandeiras",
          texto: `listou a bandeira de id=${res.data.id}`,
        };
        await api.post("system_logs", { acao: JSON.stringify(array) });
        setBandeira(...bandeira);
        setTaxas(taxa);
      })
      .catch((err) => {
        swal("Não foi possível carregar a bandeiras", err, "");
      });
  };

  const update = async () => {
    const payload = {
      nome: bandeira.nome,
      img: bandeira.img,
      taxas: taxas,
    };
    const bandeiraValidation = await yup.object().shape({
      nome: yup
        .string("Necessário que informe o nome da bandeira")
        .required("Necessário que informe o nome da bandeira"),
      img: yup
        .string("Necessário que informe a imagem da bandeira")
        .required("Necessário que informe a imagem da bandeira"),
      taxas: yup
        .string("Necessário que informe as taxas")
        .required("Necessário que informe as taxas"),
    });

    try {
      await bandeiraValidation.validate(payload, { abortEarly: true });
      api
        .put(`admin/bandeira/${id}`, payload)
        .then(async (res) => {
          let array = {
            local: "bandeiras",
            texto: `editou  a bandeira de id=${id}`,
          };
          await api.post("system_logs", { acao: JSON.stringify(array) });
          swal("Bandeira editada com sucesso", "", "success");
        })
        .catch((err) => {
          swal("Não foi possível editar a bandeira", err, "");
        });
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        swal("Erro!", `${err}`, "error");
        return;
      }
    }
  };

  const criarTaxa = useCallback(() => {
    setTaxas([...taxas, { tarifa: "", parcela: "1" }]);
  }, [taxas]);

  const handleInput = (index, valor) => {
    const newTaxa = taxas;
    newTaxa[index]["tarifa"] = valor.toString().replace(".", ",");
    setTaxas([...newTaxa]);
  };

  const handleSelect = (index, valor) => {
    const newTaxa = taxas;
    newTaxa[index]["parcela"] = valor;
    setTaxas([...newTaxa]);
  };

  console.log("TAXAS: ", taxas);

  return (
    <>
      <Container>
        <AdminMenu />

        <Content>
          <Title>Criar Bandeira</Title>

          <Form>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Nome:"
                placeholder="Nome"
                value={bandeira.nome}
                onChange={(e) => {
                  setBandeira({ ...bandeira, nome: e.target.value });
                }}
              />
            </Form.Group>
            <Form.Group>
              <Form.Field>
                <Dropzone onFileUploaded={setSelectedFile} />
              </Form.Field>
              <Form.Field>
                <Image src={bandeira.img} />
              </Form.Field>
            </Form.Group>
            <Form.Field>
              <Button color="primary" onClick={() => uploadImage()}>
                Subir imagem
              </Button>
              <Form.Field>
                <Button linked color="green" onClick={criarTaxa}>
                  Adicionar tarifas
                </Button>
              </Form.Field>
            </Form.Field>

            {taxas.map((taxa, index) => (
              <Form.Group widths="equal">
                <Form.Field>
                  <label>Taxas:</label>
                  <Input
                    type="number"
                    value={Number(taxa.tarifa.replace(",", "."))}
                    onChange={(e) => handleInput(index, e.target.value)}
                  />
                </Form.Field>
                <Form.Field>
                  <label>Parcelas:</label>
                  <select
                    value={taxa.parcela}
                    onChange={(e) => handleSelect(index, e.target.value)}
                  >
                    {parcelas.map((parcela) => (
                      <option value={parcela.id}>{parcela.valor}</option>
                    ))}
                  </select>
                </Form.Field>
              </Form.Group>
            ))}

            <Form.Group>
              <Form.Field control={Button} onClick={() => update()}>
                editar
              </Form.Field>
              <Link to="/admin/bandeiras_cart">
                <Button color="secondary">Cancelar</Button>
              </Link>
            </Form.Group>
          </Form>
        </Content>
      </Container>
    </>
  );
};

export default withRouter(EditarBandeira);
